import { render, staticRenderFns } from "./JettonPriceChart.vue?vue&type=template&id=3e597dcf"
import script from "./JettonPriceChart.vue?vue&type=script&lang=js"
export * from "./JettonPriceChart.vue?vue&type=script&lang=js"
import style0 from "./JettonPriceChart.vue?vue&type=style&index=0&id=3e597dcf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports